"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcCircleLoadingConstants = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var BC_CIRCLE_LOADING = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-circle-loading");
var BcCircleLoadingConstants = (function () {
    function BcCircleLoadingConstants() {
    }
    var _a;
    _a = BcCircleLoadingConstants;
    BcCircleLoadingConstants.BC_CIRCLE_LOADING = "".concat(BC_CIRCLE_LOADING);
    BcCircleLoadingConstants.BC_CIRCLE_LOADING_VISIBLE = "VISIBLE";
    BcCircleLoadingConstants.BC_CIRCLE_LOADING_HIDDEN = "HIDDEN";
    BcCircleLoadingConstants.BC_CIRCLE_LOADING_ACTIVE = "".concat(BC_CIRCLE_LOADING, "-active");
    BcCircleLoadingConstants.BC_CIRCLE_LOADING_CIRCLE = "".concat(BC_CIRCLE_LOADING, "-circle");
    BcCircleLoadingConstants.BC_CIRCLE_LOADING_INFO_CONTAINER = "".concat(BC_CIRCLE_LOADING, "-info-container");
    BcCircleLoadingConstants.BC_CIRCLE_LOADING_INFO = "".concat(BC_CIRCLE_LOADING, "-info");
    BcCircleLoadingConstants.BC_CIRCLE_LOADING_TITLE_DEFAULT = "Cargando...";
    BcCircleLoadingConstants.BC_CIRCLE_LOADING_SIZE_DEFAULT = "160";
    BcCircleLoadingConstants.BC_LOADER = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-loader");
    BcCircleLoadingConstants.BC_LOADER_ICON = "spinner";
    BcCircleLoadingConstants.BC_CIRCLE_LOADING_LOADER_CLASSES = ['bc-icon', 'bc-xl', _a.BC_LOADER, 'bc-circle-loading-loader-icon'];
    BcCircleLoadingConstants.BC_CIRCLE_LOADING_INFO_CLASSES = [_a.BC_CIRCLE_LOADING_INFO, 'bc-text-break'];
    return BcCircleLoadingConstants;
}());
exports.BcCircleLoadingConstants = BcCircleLoadingConstants;
